import type { Room } from "@/widgets/plan";

export const CEILING_HATCH_STEP = 300;
export const CEILING_HATCH_COLOR = "#64748b";
export const CEILING_HATCH_STROKE = 8;
export const CEILING_HATCH_DOT = 12;

const roomBounds = (room: Room) =>
	room.inner.reduce(
		(bounds, point) => ({
			minX: Math.min(bounds.minX, point.x),
			maxX: Math.max(bounds.maxX, point.x),
			minY: Math.min(bounds.minY, point.y),
			maxY: Math.max(bounds.maxY, point.y),
		}),
		{ minX: Infinity, maxX: -Infinity, minY: Infinity, maxY: -Infinity },
	);

const gridStart = (value: number) => Math.floor(value / CEILING_HATCH_STEP) * CEILING_HATCH_STEP;
const gridEnd = (value: number) => Math.ceil(value / CEILING_HATCH_STEP) * CEILING_HATCH_STEP;

export const ceilingHatchCells = (room: Room) => {
	const bounds = roomBounds(room);
	const cells: { x: number; y: number }[] = [];
	for (let x = gridStart(bounds.minX); x <= gridEnd(bounds.maxX); x += CEILING_HATCH_STEP) {
		for (let y = gridStart(bounds.minY); y <= gridEnd(bounds.maxY); y += CEILING_HATCH_STEP) {
			cells.push({ x, y });
		}
	}
	return cells;
};
